import { createApp } from 'vue';
import App from "./App.vue";
import { createRouter, createMemoryHistory  } from 'vue-router'
import MainView from "./views/MainView.vue";
import EnterView from "./views/EnterChatView.vue";
import AfterView from "./views/AfterChatView.vue";
import PostSurveyView from "./views/PostSurveyView.vue";
import ConversationView from "./views/ConversationView.vue";
import ErrorView from "./views/ErrorsStatusesView.vue";
import OohView from "./views/OohView.vue";
import VideoView from "./views/VideoView.vue";
import store from "./store.js";
const router = createRouter({
  "history": createMemoryHistory(),
  "abstract": createMemoryHistory(),
  routes: [
    {
      path: store && store.state.isSurveyOnly ? "PostSurveyView" : "/",
      name: store && store.state.isSurveyOnly ? "PostSurveyView" : "EnterView",
      component: store && store.state.isSurveyOnly ? PostSurveyView : EnterView,
      props: true
    },
    {
      path: "/afterView",
      name: "AfterView",
      component: AfterView,
    },
    {
      path: "/postSurveyView",
      name: "PostSurveyView",
      component: PostSurveyView,
    },
    {
      path: "/conversationView",
      name: "ConversationView",
      component: ConversationView,
    },
    {
      path: "/errorsStatusesView",
      name: "ErrorsStatusesView",
      component: ErrorView,
    },
    {
      path: "/oohView",
      name: "OohView",
      component: OohView,
    },
    {
      path: "/newWindowView",
      name: "newWindowView",
      component: EnterView,
    },
    {
      path: "/videoView",
      name: "videoView",
      component: VideoView,
      props: true,
    }
  ],
});

export default router;
